const API_BASE_URL = 'https://apigw.umangapp.in';
const frontBaseURL = 'https://web.umang.gov.in/frontapi/encdec/';
const CACHE_BASE_URL = 'https://cache.umang.gov.in';
export const environment = {
  production: true,
  port: 4000,
  ssrServerUrl: 'http://localhost:4000',
  baseUrl: '/landing',
  deployUrl: 'https://web.umang.gov.in',
  selfCareUrl: 'https://app.umangapp.in',
  baseUrlWithoutEnv: 'umang.gov.in/',
  API_BASE_URL: API_BASE_URL,
  cacheApiUrl: CACHE_BASE_URL,
  CORE_API_URL: `${API_BASE_URL}/core-encv1/op1`,
  frontEndUrl:`https://apigw.umang.gov.in/dept/core/api/`,
  frontendBackUrl:'https://apigw.umang.gov.in',
  CORE_CACHE_API_URL: `${CACHE_BASE_URL}/coreapi/3.0`,
  OLD_CORE_API_URL: 'https://app.umang.gov.in/t/negd.gov.in/coreApi/2.0',
  DEPT_SERVICE_URL: `${API_BASE_URL}/core-encv1/op1/openfdirdeptser`,
  frontApiUrl: frontBaseURL + 'umang/',
  stagAuthToken: 'Bearer f410bcb9-c874-32ab-b502-7b01561e9b2f',
  resultsJSONApiKey: 'mkWxtFO28l0Ua3rrXNrBwLN2YXPfmEHMz0xIRXVC',
  deptBaseBearerToken: 'Bearer 02f6dd09-7573-3c7d-a9e7-7f0f429f9d50',
  xApiKey: 'VKE9PnbY5k1ZYapR5PyYQ33I26sXTX569Ed7eqyg',
  forntendApikey:'2qYCUKTEFJ6jSvZVcHv5ZxcauMUMhbO33MoTw940',
  firebaseConfig: {
    apiKey: "AIzaSyC5PeVJocNg5IdO2hiOKSyR6V8nnMGGL7c",
    authDomain: "umang-c17d7.firebaseapp.com",
    databaseURL: "https://umang-c17d7.firebaseio.com",
    projectId: "umang-c17d7",
    storageBucket: "umang-c17d7.appspot.com",
    messagingSenderId: "616074837787",
    appId: "1:616074837787:web:42cd8212ce4a321c25ddbe",
    measurementId: "G-K999J6ZEN8"
    
    // apiKey: 'AIzaSyC5PeVJocNg5IdO2hiOKSyR6V8nnMGGL7c',
    // authDomain: 'umang-c17d7.firebaseapp.com',
    // databaseURL: 'https://umang-c17d7.firebaseio.com',
    // projectId: 'umang-c17d7',
    // storageBucket: 'umang-c17d7.appspot.com',
    // messagingSenderId: '616074837787',
    // appId: '1:616074837787:web:99b487f05633d8b225ddbe',
    // measurementId: 'G-HJWLL31WJX',
  },
  appVersion:  require('../../package.json').version,
  
  mySchemeBaseUrl: 'https://social.api-setu.in/dic/myscheme/srv',
  isProductionMyScheme: true,
  mySchemeDashboardUrl:'https://devapi.myscheme.gov.in/v3/public/schemes',
  locationApiKey: 'ykxzbmihrjcm7534z55ojgp5hb5j6ba4',
  visitedSchemeBaseUrl: 'https://apigw.umang.gov.in/search/core/api',
  exploreSchemeBaseUrl: 'https://social.api-setu.in/dic/myscheme/srv',
  mySchemeRecommendedUrl: 'https://cache.umang.gov.in/scheme/core/api',
  nssoUrl: 'https://apigw.umang.gov.in',
  nssoToken: '2qYCUKTEFJ6jSvZVcHv5ZxcauMUMhbO33MoTw940',
  appVersions: {
    android: 62,
    ios: 18,
  },
  userActivityUrl: 'https://apigw.umang.gov.in',

};
